import { axiosCustom } from '@/plugins/axios'

export class Auth {
  /**
   * Ссылка на авторизацию через бэкенд.
   * Без provider — собственная форма Keycloak (логин/пароль реалма),
   * с провайдером (например, 'leader-id') — сразу внешний IdP.
   */
  authorize(provider) {
    const params = new URLSearchParams()

    if (provider) {
      params.set('via', provider)
    }

    const query = params.toString()

    return `/api/v3/users/login${query ? `?${query}` : ''}`
  }

  getAccessToken(code) {
    const params = new URLSearchParams({
      code: code,
    }).toString()

    return axiosCustom.get(`/v3/users/callback?${params}`).then((response) => response.data)
  }
}
